<template>
  <div>
    <label>Cliente</label>

    <div class="w3-row">
      <div class="w3-col s4 l2">
        <input
          type="text"
          @keyup.enter="inserirDadoPorChave()"
          ref="chavePesquisa"
          class="w3-input w3-border input-codigo"
          v-model="chave_pesquisa"
          :disabled="somenteLeitura == 'S'"
          v-bind:placeholder="placeholder_codigo"
          v-on:blur="onBlurChave()"
          maxlength="15"/>
      </div>

      <div class="w3-col s8 l10">
        <div class="input-container">
          <input
            class="input-registro-selecionado w3-border"
            type="text"
            v-model="descricao_cliente_selecionado"
            @click="abrirPesquisa()"
            :disabled="somenteLeitura == 'S'"
            placeholder="Clique para pesquisar"
            readonly/>

          <i
            v-if="somenteLeitura == 'N'"
            class="fas fa-minus icone w3-border-top w3-border-right w3-border-bottom"
            @click="limparDados"
          />
        </div>
      </div>
    </div>

    <pesquisa-clientes
      ref="pesquisaClientes"
      @confirmar="carregar"
    />

  </div>
</template>

<script>
  import Biblioteca from '@/components/Repositorio/Biblioteca'
  import RCliente from '@/components/Rest/RCliente/RCliente.js'
  import PesquisaClientes from '@/components/Pesquisas/PesquisaClientes'

  export default {
    name: 'FrameCliente',

    components: {
      PesquisaClientes
    },

    props: {
      somenteLeitura: {
        required: true,
        type: String,
        default: 'N'
      },

      verificarDados: {
        required: false,
        type: Function,
        default: function (cliente) {
          return true;
        }
      },

      clienteSelecionado: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      }
    },

    data() {
      return {
        descricao_cliente_selecionado: '',

        cliente_selecionado: {},
        chave_pesquisa: '',
        placeholder_codigo: 'Cód.'
      }
    },

    methods: {
      async inserirDadoPorChave(chave) {
        if (this.valorInt(chave) > 0) {
          this.chave_pesquisa = chave;
        }

        let cadastro_id = this.valorInt(this.chave_pesquisa);

        if
          (
            (this.chave_pesquisa == '') ||
            (cadastro_id <= 0)
          )
        {
          Biblioteca.exclamar('Digite um código válido!');
          return;
        }

        try {

          let parametros = {
            cadastro_id: cadastro_id
          }

          let retorno = await RCliente.buscarDadosCompletoCliente(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.carregar(JSON.parse(JSON.stringify(retorno.dados)));
        }
        catch (e) {
          this.limparDados();
          Biblioteca.exclamar(e.message);
        }
      },

      abrirPesquisa() {
        this.$refs.pesquisaClientes.abrir('N');
      },

      async carregar(cliente) {
        this.chave_pesquisa = '';

        if ((!cliente) || (!cliente.cadastro_id)) {
          this.limparDados();
          return;
        }

        if (await !this.verificarDados(cliente)) {
          return;
        }

        this.cliente_selecionado = JSON.parse(JSON.stringify(cliente));
        this.placeholder_codigo = Biblioteca.nPadrao(this.cliente_selecionado.cadastro_id, 0);
        this.descricao_cliente_selecionado = this.cliente_selecionado.nome_razao_social;

        this.$emit('confirmar', this.cliente_selecionado);
      },

      onBlurChave() {
        if (this.cliente_selecionado.cadastro_id) {
          if (this.cliente_selecionado.cadastro_id != this.valorInt(this.chave_pesquisa)) {
            this.chave_pesquisa = '';
          }
        }
        else {
          this.limparDados();
        }
      },
     
      limparDados() {
        this.chave_pesquisa = '';
        this.placeholder_codigo = 'Cód.';
        this.descricao_cliente_selecionado = '';
        this.cliente_selecionado = {};
        this.$emit('limparDados');
      },

      selecao() {
        if (this.cliente_selecionado.cadastro_id) {
          return this.cliente_selecionado;
        }

        return undefined;
      },

      valor(numero_str) {
        return Biblioteca.valor(numero_str);
      },

      valorInt(numero) {
        return Biblioteca.valorInt(numero);
      }
    },

    created() {
      if (this.clienteSelecionado) {
        this.carregar(this.clienteSelecionado);
      }
    }
  }
</script>

<style escoped>
  .card-item {
    background-color: #f3f3f3;
    border-radius: 10px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
    margin-bottom: 5px;
    padding: 3px !important;
  }

  .input-codigo {
    padding: 10px 15px;
    border-radius: 0px;
    position: relative;
    z-index: 0;
    font-weight: bold;
    border-right-style: none!important;
  }

  .input-container {
    display: -ms-flexbox; 
    display: flex;
    position: relative;
    z-index: 1;
    margin-left: -20px;
    width: calc(100% + 20px);
  }

  .icone {
    padding: 11px;
    background: gray;
    color: white;
    min-width: 15px;
    text-align: center;
    border-left-style: none
  }

  .icone:active {
    background-color: #ccc;
    box-shadow: 0 1px #666;
    transform: translateY(1px);
  }

  .input-registro-selecionado {
    width: 100%;
    padding: 10px;
    outline: none;
    cursor: pointer;
    font-weight: bold;
    border-right-style: none;
  }

</style>


// WEBPACK FOOTER //
// src/components/Frames/FrameCliente.vue